import { NavBarDataInterface } from '@simOn/common/containers';

export const STAGES_PAGE_DATA: NavBarDataInterface = {
  headerTitle: $localize`:@@STAGES_TITLE:Stages`,
  shortTitle: $localize`:@@STAGES_TITLE:Stages`,
  navLinks: [],
  activeLinkIndex: 0
};
